class FormDate extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      text: this.fromIso(props.date),
      date: props.date,
      validating: true
    };
  }

  // "YYYY-MM-DD" to "MM/DD/YYYY"
  fromIso(str) {
    if (str) {
      var s = str.split("-");

      return [+s[1], +s[2], s[0]].join("/");
    }

    return "";
  }

  // "MM/DD/YYYY" to "YYYY-MM-DD"
  toIso(str) {
    var s = str.split("/");

    return [s[2], ("0" + s[0]).substr(-2), ("0" + s[1]).substr(-2)].join("-");
  }

  onFocus(evt) {
    this.setState({
      validating: false
    });
  }

  onChange(evt) {
    var text = evt.target.value.trim();
    var iso = null;

    this.setState({
      text
    });

    if ((new RegExp(FormDate.PATTERN)).test(text)) {
      iso = this.toIso(text);
    }

    this.props.onChange(iso);
  }

  onBlur(evt) {
    this.setState({
      validating: true
    });
  }

  render() {
    var { name, disabled } = this.props;
    var { text, validating } = this.state;

    return (
      <span className="mc-form-date">
        <input
          type="text"
          size="12"
          maxLength="10"
          pattern={validating ? FormDate.PATTERN : null}
          name={name || "date"}
          value={text}
          onChange={this.onChange.bind(this)}
          onFocus={this.onFocus.bind(this)}
          onBlur={this.onBlur.bind(this)}
          disabled={disabled}/>
          <small>{"MM/DD/YYYY"}</small>
      </span>
    );
  }
}

FormDate.PATTERN = "^\\d{1,2}\/\\d{1,2}\/\\d{4}$";

module.exports = FormDate;